import { useTranslation } from 'react-i18next';

import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import { useMixpanel } from 'packages/kakapo-ui-application/hooks/useMixpanel';

import InboxTaskItem from '../components/InboxTaskItem';

export default function InboxFeedbackRequestPendingTask({
	task,
	onAction,
	refresh,
}: {
	task: graphql.InboxTask;
	onAction: () => void;
	refresh: () => void;
}) {
	const mixpanel = useMixpanel();
	const history = useHistory();
	const { t } = useTranslation();

	const feedbackResponse = task.feedbackResponse!;

	const { requestor } = feedbackResponse;

	const onClick = () => {
		mixpanel?.track('inbox.tasks.feedbackRequestPending.respond');
		onAction();
		history.push(`/user/${requestor.id}/feedback-v2/${feedbackResponse.id}/respond`);
	};

	return (
		<InboxTaskItem
			task={task}
			title={t('inbox.tasks.feedbackRespondToOutstandingSelf.title', {
				targetEmployeeFullName: `${requestor.firstName} ${requestor.lastName}`,
			})}
			date={task.createdAt}
			buttonTitle={t('inbox.tasks.button.start')}
			onClick={onClick}
			refresh={refresh}
		/>
	);
}
